export function isNewOrDuplicate(id: string): boolean {
    return isNew(id) || isDuplicate(id);
}

export function isNew(id: string): boolean {
    return id == "new";
}

export function isDuplicate(id: string): boolean {
    return id == "duplicate";
}
